// // function for dynamic sorting
// function compareValues(key, order='asc') {
//     return function(a, b) {
//         if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
//             // property doesn't exist on either object
//             return 0;
//         }
//         var varA = (typeof a[key] === 'string') ?
//             a[key].toUpperCase() : a[key];
//         var varB = (typeof b[key] === 'string') ?
//             b[key].toUpperCase() : b[key];
//
//         var comparison = 0;
//         if (varA > varB) {
//             comparison = 1;
//         } else if (varA < varB) {
//             comparison = -1;
//         }
//
//         // Return asc or desc order based on it
//         return (
//             (order == 'desc') ? (comparison * -1) : comparison
//         );
//     };
// }
//
// var FilterShow = (function () {
//     function FilterShow(el, url) {
//         var newsJson = new Array();
//         var newfilterJson = new Array();
//         this.el = el;
//         this.url = url;
//         this.init();
//     }
//
//     FilterShow.prototype.init = function () {
//         this.loadmore = 12;
//         this.intialstate = 0;
//         this.categoryText = 'All';
//         this.yearText = 'All';
//         this.dropText = 'ASC';
//         this.counter = 0;
//         this.method();
//         this.categoryClick();
//         this.yearClick();
//         this.ArrangeOrder();
//         this.loadMore();
//     }
//
//     FilterShow.prototype.method = function () {
//         var _self = this;
//         var promise = fetch(_self.url);
//         promise.then(function (response) {
//             return response.json();
//         }).then(function (data) {
//             newsJson = data;
//             newfilterJson = newsJson;
//             _self.repeatMethod(newsJson);
//             return newsJson;
//         }).catch(function (error) {
//             console.log("Json not loaded:" + error);
//         });
//     };
//
//     FilterShow.prototype.repeatMethod = function (data) {
//         var _self = this;
//         if (data.length === 0) {
//             return jQuery(_self.el).find('.card-outer').append('<div class="no-item"><h4>No item found</h4></div>')
//         }
//         data.slice(_self.intialstate, _self.loadmore).map(function (item, i) {
//             jQuery(".filter-search").find('.card-outer').append('' +
//                 '<div class="col-sm-6 col-md-6 col-lg-4 card-wrapper wow fadeIn news '+item.class+'" data-wow-delay="' + (i + 3) / 10 + 's">' +
//                 '<a href="' + item.link + '">' +
//                 '<div class="card card-content">' +
//                 '<div class="card-img-top img-wrapper">' +
//                 '<img src="' + item.image + '" alt="' + item.alt + '">' +
//                 '</div>' +
//                 '<div class="card-body text-content">' +
//                 '<span class="card-subtitle">' + item.date + '</span>' +
//                 '<h5 class="card-title">' + item.title + '</h5>' +
//                 '<p class="card-text">' + item.content + '</p>' +
//                 // '<p class="card-text">' + item.content + '</p>' +
//                 '</div>' +
//                 '</div>' +
//                 '</a>' +
//                 '</div>')
//         });
//     }
//
//     FilterShow.prototype.categoryClick = function () {
//         var _self = this;
//         $(_self.el).find('.filter-nav .filter-inner .category > li').on('click', function () {
//             $(this).parent().children().removeClass('active');
//             $(this).addClass('active');
//             _self.categoryText = $(this).text();
//             _self.filterElement();
//         });
//     }
//
//     FilterShow.prototype.yearClick = function () {
//         var _self = this;
//         $(_self.el).find('.filter-nav .filter-inner .years > li').on('click', function () {
//             $(this).parent().children().removeClass('active');
//             $(this).addClass('active');
//             _self.yearText = $(this).text();
//             _self.filterElement();
//         });
//
//     }
//
//     FilterShow.prototype.ArrangeOrder = function () {
//         var _self = this;
//         $(_self.el).find('.filter-nav .sort-div > ul > li > ul > li').on('click', function () {
//             _self.dropText = $(this).text();
//             this.newText = $(this).parents('.sort-div').find('span').text();
//             $(this).parents('.sort-div').find('span').text(_self.dropText);
//             $(this).parent().children().removeClass('drop-active');
//             $(this).addClass('drop-active');
//             if(this.newText === _self.dropText)
//                 return false;
//             _self.filterElement();
//         });
//     };
//
//     FilterShow.prototype.loadMore = function () {
//         var _self = this;
//
//         $('body .filter-search .load-more').on('click', function (e) {
//             e.preventDefault();
//             _self.intialstate = _self.loadmore;
//             _self.loadmore += 12;
//             _self.repeatMethod(newfilterJson);
//             _self.loadMoreHide(_self.loadmore);
//         });
//     }
//
//     FilterShow.prototype.loadMoreHide = function (loadmore) {
//         var _self = this;
//         if (loadmore > (newfilterJson.length - 1)) {
//             $('body .filter-search .load-more').css('display', 'none');
//         }
//         else {
//             $('body .filter-search .load-more').css('display', '');
//         }
//     }
//
//     FilterShow.prototype.beforeInit = function () {
//         var _self = this;
//         _self.loadmore = 12;
//         _self.intialstate = 0;
//         newfilterJson = [];
//     }
//
//     FilterShow.prototype.afterInit = function () {
//         var _self = this;
//         if (_self.dropText === 'Descending') {
//             newfilterJson.sort(compareValues('date', 'desc'));
//             _self.counter = 1;
//         }
//         else if (_self.dropText === 'Ascending') {
//             newfilterJson.sort(compareValues('date', 'asc'));
//             _self.counter = 0;
//         }
//         jQuery('.filter-search .card-outer > div').remove();
//         _self.repeatMethod(newfilterJson);
//         _self.loadMoreHide(_self.loadmore);
//     }
//
//     FilterShow.prototype.filterElement = function () {
//         var _self = this;
//         _self.beforeInit();
//         newsJson.filter(function (item) {
//             var arr = item.date.split(',');
//             if (_self.categoryText === 'All' && _self.yearText === 'All') {
//                 newfilterJson = this.newsJson;
//                 return newfilterJson;
//             }
//             else if ((item.category === _self.categoryText) && _self.yearText === 'All') {
//                 newfilterJson.push(item);
//             }
//             else if ((parseInt(arr[1]) == _self.yearText) && _self.categoryText === 'All') {
//                 newfilterJson.push(item);
//             }
//             else if ((item.category === _self.categoryText) && (parseInt(arr[1]) == _self.yearText)) {
//                 newfilterJson.push(item);
//             }
//         });
//         _self.afterInit();
//     }
//
//     return FilterShow;
// }());
//
// (function ($) {
//     $.fn.scriptFilters = function (options) {
//         // Default options
//         return this.each(function () {
//             var settings = $.extend({
//                 url: ''
//             }, options);
//             var item = new FilterShow(this, settings.url);
//         });
//     }
// })(jQuery);
//
